import Hero from '../components/Hero'
import Section from '../components/Section'
import ProjectCard from '../components/ProjectCard'
import Reveal from '../components/Reveal'

export default function Home() {
  return (
    <>
      <Hero />

      <Section
        title="Was wir bauen"
        subtitle="Von der Idee bis zum Deployment – Fokus auf Qualität, Sicherheit und Flexibilität."
      >
        <div className="grid gap-6 md:grid-cols-3">
          <Reveal y={24} once={false}>
            <div className="rounded-2xl glass p-6">
              <h3 className="font-semibold">Microservices</h3>
              <p className="mt-2 text-slate-300">
                Wir entwickeln Anwendungen als eigenständige Dienste, die über saubere Schnittstellen kommunizieren. </p>
            </div>
          </Reveal>

          <Reveal delayMs={120} y={24} once={false}>
            <div className="rounded-2xl glass p-6">
              <h3 className="font-semibold">MERN Stack</h3>
              <p className="mt-2 text-slate-300">
                Moderne Full-Stack-Entwicklung mit MongoDB, Express, React und Node.js – skalierbar, performant und cloudbereit.
              </p>
            </div>
          </Reveal>

          <Reveal delayMs={240} y={24} once={false}>
            <div className="rounded-2xl glass p-6">
              <h3 className="font-semibold">DevOps & Cloud</h3>
              <p className="mt-2 text-slate-300">
                Containerisierung, Automatisierte Deployments und Observability bilden das Fundament unserer Cloud-Architektur.
              </p>
            </div>
          </Reveal>
        </div>
      </Section>

      <Section title="Aktuelles Projekt">
        <div className="grid gap-6 md:grid-cols-2">
          <Reveal once={false}>
            <ProjectCard
              title="NFT-Hub (MVP)"
              description="Ein schlanker NFT-Marktplatz mit Stripe-Bezahlung, Creator-Abos und Zertifikats-PDFs."
              image="/Landingfull2.png"
              href="/nft-hub"
              tags={['React', 'Node', 'Stripe', 'Cloudinary', 'MongoDB', 'Pupeteer']}
            />
          </Reveal>

          <Reveal delayMs={160} y={16} once={false}>
            <div className="rounded-2xl glass p-6">
              <h3 className="text-xl font-semibold">Warum dieses Projekt?</h3>
              <p className="mt-3 text-slate-300">
                Wir sehen in jedem Projekt die Chance, neue Technologien zu verstehen, strukturiert zu erproben und sauber umzusetzen.
                Dabei geht es uns nicht um schnellen Fortschritt,
                sondern um technische Qualität, nachvollziehbare Prozesse und Systeme,
                die langfristig Bestand haben.
              </p>
              <a
                href="/nft-hub"
                className="mt-5 inline-block rounded-xl bg-brand-500 px-4 py-2 font-semibold hover:bg-brand-400 transition"
              >
                Mehr zum NFT-Hub
              </a>
            </div>
          </Reveal>
        </div>
      </Section>
    </>
  )
}
